import request from "root/js/request";

export const getParsersSocialPostsCount = async params => {
  
  const response = await request({
    url: `parsers/social/posts/count/`,
    method: "get",
    params: {
      ...params,
    },
  });
  return response.data;
};
